/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { useGrabXFeatureFlag, GrabXDataTypes } from "grabx"
import { MerchantPortalFeatureFlag } from "grabx/constants"
import { generateDefaultFacets } from "grabx/facets"
import { GrabXRTKQueryMigrationEndpointsFlag } from "grabx/types"

export interface RtkQueryMigrationEndpointsFlagResult {
  flags: GrabXRTKQueryMigrationEndpointsFlag
  isLoading: boolean
}

const DEFAULT_CONFIG: GrabXRTKQueryMigrationEndpointsFlag = {
  searchOutlets: false,
  searchStore: false,
  fetchMerchantDetail: false,
  fetchItemsWithoutPhotoCount: false,
  fetchIncidentStat: false,
  submitReportReview: false,
  postMerchantReviewThrottle: false,
  fetchMerchantAggregate: false,
  fetchIncidentList: false,
  loadConfig: false,
  uploadReportReviewImg: false,
  fetchOrderEta: false,
  fetchCityList: false,
  fetchOrderCancelReasons: false,
  fetchOrderSummary: false,
  reviewOrderChanges: false,
  submitOrderChanges: false,
  cancelOrder: false,
  fetchOrderExportedMpaFile: false,
  fetchOrderExportedFile: false,
  fetchStoreDetailFromMaxAPI: false,
  fetchOrderByID: false,
  updateStoreStatus: false,
  markOrder: false,
  deleteCategory: false,
  changeModifierAvailability: false,
  createMenuGroup: false,
  upsertItemV2: false,
  publishMenuGroup: false,
  deleteMenuGroup: false,
  deleteItem: false,
  getTranslation: false,
  linkItemToModifierGroup: false,
  resetMenuGroup: false,
  searchItems: false,
  fetchStoreOpenStatus: false,
  fetchDepartmentsForGrabCategory: false,
  getVerifyTranslation: false,
  createModifierGroup: false,
  getSingleTranslation: false,
  deleteModifierGroup: false,
  fetchMenuGroupList: false,
  fetchSubdepartmentsForGrabCategory: false,
  proofModifierGroup: false,
}

const useRtkQueryMigrationEndpointsFlag = (): RtkQueryMigrationEndpointsFlagResult => {
  const { data = DEFAULT_CONFIG, isLoading } = useGrabXFeatureFlag<
    GrabXRTKQueryMigrationEndpointsFlag
  >(
    MerchantPortalFeatureFlag.rtkQueryMigrationEndpointsFlag,
    GrabXDataTypes.Json,
    DEFAULT_CONFIG,
    generateDefaultFacets(),
  )

  return { flags: data, isLoading }
}

export default useRtkQueryMigrationEndpointsFlag
